import { sqliteTable, text, integer, real, index } from "drizzle-orm/sqlite-core";
import { rentalBookings } from "./rental-bookings";
import { rentalPickups } from "./rental-pickups";
import { bookingVehicles } from "./booking-vehicles";
import { vehicles } from "./vehicles";

// ============================================================================
// pickup_vehicle_lines — ข้อมูลรับรถรายคันในใบรับรถเดียวกัน
// ============================================================================
export const pickupVehicleLines = sqliteTable("car_rental_pickup_vehicle_lines", {
  id: text("id").primaryKey(),
  companyId: text("company_id").notNull(),
  pickupId: text("pickup_id").notNull().references(() => rentalPickups.id),
  bookingId: text("booking_id").notNull().references(() => rentalBookings.id),
  bookingVehicleId: text("booking_vehicle_id").references(() => bookingVehicles.id),
  vehicleId: text("vehicle_id").notNull().references(() => vehicles.id),
  sortOrder: integer("sort_order").notNull().default(0),

  mileageOut: real("mileage_out"),
  fuelLevelOut: text("fuel_level_out", {
    enum: ["empty", "1/4", "1/2", "3/4", "full"],
  }),
  vehicleCondition: text("vehicle_condition"),
  existingDamageNotes: text("existing_damage_notes"),
  pickupRemarks: text("pickup_remarks"),

  createdAt: text("created_at").notNull(),
  createdBy: text("created_by"),
  updatedAt: text("updated_at").notNull(),
  updatedBy: text("updated_by"),
  deletedAt: text("deleted_at"),
  deletedBy: text("deleted_by"),
}, (table) => ({
  companyPickupIdx: index("pvl_company_pickup_idx").on(table.companyId, table.pickupId),
  companyBookingIdx: index("pvl_company_booking_idx").on(table.companyId, table.bookingId),
  companyVehicleIdx: index("pvl_company_vehicle_idx").on(table.companyId, table.vehicleId),
}));

export type PickupVehicleLine = typeof pickupVehicleLines.$inferSelect;
export type NewPickupVehicleLine = typeof pickupVehicleLines.$inferInsert;
